import { useSelector } from 'react-redux';
import { checkPropTypes, objectOf, string } from 'prop-types';

import { ENGLISH, LANGUAGES_MAP } from '@lootboy/translations/config';

import { languageSelector } from '~/redux/selectors';

function ImageTranslator({ src, alt, ...props }) {
  const language = useSelector(languageSelector);

  return (
    <img
      src={src[language] || src[ENGLISH]}
      alt={alt}
      {...props}
    />
  );
}

ImageTranslator.propTypes = {
  alt: string.isRequired,
  src(props, propName, componentName) {
    const src = props[propName];
    const errorGenerator = (reason) =>
      new Error(
        `Invalid prop \`${propName}\` supplied to` +
          ` \`${componentName}\`. ${reason} Validation failed.`,
      );
    if (!src[ENGLISH]) {
      return errorGenerator('Missing default value.');
    }

    if (!Object.keys(src).every((lang) => LANGUAGES_MAP[lang])) {
      return errorGenerator('Wrong translation key.');
    }
    return checkPropTypes(
      { src: objectOf(string) },
      props,
      propName,
      componentName,
    );
  },
};

export default ImageTranslator;
